import { StateCreator } from 'zustand';
import { defaultLinkModel, ILinkModel } from './types/types';

export interface ICreateLinkSlice {
  linkSearchValue: string;
  setLinkSearchValue: (linkSearchValue: string) => void;
  linkArchiveSwitch: boolean;
  setLinkArchiveSwitch: (archiveSwitchValue: boolean) => void;
  linkSideSheetData: ILinkModel;
  setLinkSideSheetData: (linkSideSheetData: ILinkModel) => void;
  updateLinkSideSheetData: (event: any) => void;
  resetLinkSideSheetState: () => void;
  setLinkShowToastState: (toastMsg: string, toastType: string) => void;
  resetLinkToastState: () => void;
  linkToastMsg: string,
  linkToastType: string,
  linkShowToast: boolean
  setLinkDeleteDialogOpen: (linkDeleteDialogOpen: boolean) => void;
  linkDeleteDialogOpen: boolean
  setIsLinkValidationState: (isLinkValidationState: boolean) => void;
  isLinkValidationState: boolean;
  setLinkPermission: (linkPermission: any) => void;
  linkPermission: any;
  linkNotifications: any,
  setLinkNotifications: (linkNotifications: any) => void;
}

const resetLinkSideSheetState = (set: any) => () =>
  set((state: any) => {
    return {
      linkSideSheetData: defaultLinkModel
    };
  });

const setLinkShowToastState = (set: any) => (toastMsg: string, toastType: string) =>
  set((state: any) => {
    return {
      linkToastMsg: toastMsg,
      linkToastType: toastType,
      linkShowToast: true
    };
  });

const resetLinkToastState = (set: any) => () =>
  set((state: any) => {
    return {
      linkToastMsg: '',
      linkToastType: '',
      linkShowToast: false
    };
  });

const _setLinkNotifications = (set: any) => (notifications: any) =>
  set((state: any) => {
    return {
      linkNotifications: [...notifications]
    };
  });

export const createLinkSlice: StateCreator<ICreateLinkSlice,
  [['zustand/devtools', never]],
  [],
  ICreateLinkSlice> = (set) => {
    return {
      linkToastMsg: '',
      linkShowToast: false,
      linkToastType: '',
      linkSearchValue: '',
      linkArchiveSwitch: false,
      linkNotifications: [],
      setLinkNotifications: _setLinkNotifications(set),
      setLinkSearchValue: (linkSearchValue: any) => set(() => ({ linkSearchValue })),
      setLinkArchiveSwitch: (linkArchiveSwitch: any) => set(() => ({ linkArchiveSwitch })),
      linkSideSheetData: defaultLinkModel as unknown as | ILinkModel,
      resetLinkSideSheetState: resetLinkSideSheetState(set),
      setLinkShowToastState: setLinkShowToastState(set),
      resetLinkToastState: resetLinkToastState(set),
      setLinkSideSheetData: (linkSideSheetData) => set(() => ({ linkSideSheetData })),
      setLinkDeleteDialogOpen: (linkDeleteDialogOpen) => set(() => ({ linkDeleteDialogOpen })),
      linkDeleteDialogOpen: false,
      setIsLinkValidationState: (isLinkValidationState) => set(() => ({ isLinkValidationState })),
      isLinkValidationState: false,
      setLinkPermission: (linkPermission: any) => set(() => ({ linkPermission })),
      linkPermission: {},
      updateLinkSideSheetData: (event) =>
        set((state: any) => {
          return {
            linkSideSheetData: {
              ...state.linkSideSheetData,
              [event.fieldName]: event.value,
            }
          };
        }),
    };
  };